export const FIELD_MAPPINGS = {
  companycode: 'companyCode',
  countrytaxtype: 'countryTaxTypeDescription',
  adjustmenttype: 'adjustmentType',
  description: 'description',
  amountfrom: 'amountFrom',
  frequency: 'frequency',
  account: 'account',
  annualcumulative: 'annualCum',
  amount: 'amount',
  multiplier: 'multiplier',
  booktotaxdescription: 'tagDescription',
};

export const IMPORT_RANGE_LAST_COLUMN = 'K';
